import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class TrainingEvents extends Component {

    standardRow = (trainingEvent) => {
        this.props.info('TrainingEvents.js/standardRow (trainingEvent)', trainingEvent);
        return (
            <Row className="adminRow pointer widgetRow text-left" onClick={() => this.props.onEdit(trainingEvent.trainingEventId)}>
                <Col md={4}>{trainingEvent.topic}</Col>
                <Col md={4}>{trainingEvent.date}</Col>
                <Col md={4}>{trainingEvent.trainerName}</Col>
            </Row>
        )
    }

    editRow = (trainingEvent) => {
        this.props.log('TrainingEvents.js/editRow (trainingEvent)', trainingEvent);
        return (<>
            <Row className="adminRow activeTab">
                <Col md={8}>
                    <Form inline>
                        <FormGroup className="px-2">
                            <Input
                                placeholder="New Event Topic"
                                type="text"
                                name="topic"
                                value={this.props.isFieldNull(this.props.editTrainingEvent.topic)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>

                        <FormGroup className="px-2">
                            <Input
                                placeholder="Event Date"
                                type="date"
                                name="date"
                                value={this.props.isFieldNull(this.props.editTrainingEvent.date)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                placeholder="Trainer Name"
                                type="text"
                                name="trainerName"
                                value={this.props.isFieldNull(this.props.editTrainingEvent.trainerName)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={4} className="text-right">
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Training Events">
                        <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Training Event">
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Training Event">
                        <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(trainingEvent.trainingEventId)} title="Delete Training Event">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
            <Row className="adminRow activeTab">
                <Col md={5}>
                    <FormGroup className="px-2">
                        <Input
                            placeholder="Event Topic Details"
                            type="textarea"
                            rows={6}
                            name="topicDetails"
                            value={this.props.isFieldNull(this.props.editTrainingEvent.topicDetails)}
                            onChange={e => this.props.onChange(e, 'edit')} />
                    </FormGroup>
                </Col>
                <Col md={3} className="text-right">
                     Employee Attendance
                </Col>
                <Col md={4} className="text-left p-3 pl-5 maxHpanel">
                    {[...this.props.employees]
                        .map(employee => (
                            <Row key={employee.employeeId}>
                                <Label for={"employee_" + employee.employeeId}>
                                    <Input
                                        type="checkbox"
                                        name="employees"
                                        id={"employee_" + employee.employeeId}
                                        checked={this.props.isFieldNull(this.props.editTrainingEvent.employees.findIndex(i => i === parseInt(employee.employeeId)) > -1, true)}
                                        onChange={e => this.props.onChange(e, 'edit')}
                                    />{employee.lastName}, {employee.firstName}
                                </Label>
                            </Row>
                        ))}
                </Col>
            </Row>
        </>
        )
    }

    addRow = () => {
        this.props.info('TrainingEvents.js/addRow');
        return (<>
            <Row className="py-4 text-left align-top ">
                <Col>
                    <Form inline>
                        <FormGroup className="px-2">
                            <Input
                                placeholder="New Event Topic"
                                type="text"
                                name="topic"
                                value={this.props.isFieldNull(this.props.newTrainingEvent.topic)}
                                onChange={e => this.props.onChange(e)} />
                        </FormGroup>

                        <FormGroup className="px-2">
                            <Input
                                placeholder="Event Date"
                                type="date"
                                name="date"
                                value={this.props.isFieldNull(this.props.newTrainingEvent.date)}
                                onChange={e => this.props.onChange(e)} />
                        </FormGroup>
                        <FormGroup className="px-2">
                            <Input
                                placeholder="Trainer Name"
                                type="text"
                                name="trainerName"
                                value={this.props.isFieldNull(this.props.newTrainingEvent.trainerName)}
                                onChange={e => this.props.onChange(e)} />
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={3} className="text-right">
                    <Button
                        disabled={this.props.newTrainingEvent.topic === '' || this.props.newTrainingEvent.date === ''}
                        color="primary"
                        onClick={this.props.handleAdd}
                    >Add Event</Button>
                </Col>
            </Row>
            <Row>
                <Col md={9}>
                    <FormGroup className="px-2">
                        <Input
                            placeholder="Event Topic Details"
                            type="textarea"
                            rows={6}
                            name="topicDetails"
                            value={this.props.isFieldNull(this.props.newTrainingEvent.topicDetails)}
                            onChange={e => this.props.onChange(e)} />
                    </FormGroup>
                </Col>
            </Row>
        </>
        )
    }

    render() {
        this.props.info('TrainingEvents.js/render');
        return (
            <Container className="adminContainer" fluid>
                {this.props.trainingEvents.map(trainingEvent => (
                    <Fragment key={trainingEvent.trainingEventId}>{this.props.editTrainingEvent.trainingEventId === trainingEvent.trainingEventId ? this.editRow(trainingEvent) : this.standardRow(trainingEvent)}</Fragment>
                ))}
                <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Training Events">
                    {this.addRow()}
                </PermissionWrapper>
            </Container>
        );

    }
}

export default TrainingEvents;
